import { useState } from "react";
import { faqData } from "@/mocks/landingData";

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="section-padding relative">
      <div className="container-main max-w-3xl">
        <div className="text-center mb-14">
          <span className="v2-section-label justify-center">
            <span className="w-8 h-px bg-teal-400" />
            الأسئلة الشائعة
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mt-4">
            <span className="title-line-1">لديك سؤال؟</span>
            <span className="title-line-2 v2-gradient-text">نجيبك</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqData.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.question}
                className={`v2-glass-card overflow-hidden transition-all duration-300 ${
                  isOpen
                    ? "border-teal-400/30 shadow-[0_0_30px_-10px_rgba(45,212,191,0.2)]"
                    : ""
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-right"
                >
                  <span className="font-bold text-white text-sm md:text-base">
                    {item.question}
                  </span>
                  <span
                    className={`flex-shrink-0 w-8 h-8 rounded-full bg-teal-500/10 border border-teal-400/20 flex items-center justify-center transition-transform duration-300 ${
                      isOpen ? "rotate-180 bg-teal-500/20" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-teal-400" />
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 md:px-6 pb-5 md:pb-6 text-slate-400 text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
